var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"h-padding-left-l h-padding-right-l"},[_c('PatientReportForm')],1),_c('div',{staticClass:"h-margin-top-l"},[_c('PendingReports')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }